


























import Vue from "vue";
import store from "store";

export default Vue.extend({
  name: "download-tip-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: [],
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.stat("xiaozhan_wechat_tips_pop_show", {});
      }
    }
  },
  methods: {
    stat(action: string, data: any) {
      this.$stat("xiaozhan", action, data);
    },
    close() {
      this.$emit("close");
      const downloadTipDialogVisible = store.get("download_tip_dialog_visible");
      if (this.checked[0] && !downloadTipDialogVisible) {
        store.set("download_tip_dialog_visible", "hidden");
      }
    },
    iconClose() {
      this.close();
    },
    handleClick() {
      this.stat("xiaozhan_wechat_tips_pop_click", {
        clickid: "look",
        is_not_show: this.checked[0] ? 1 : 0,
      });
      this.$emit("confirm");
      setTimeout(() => {
        this.close();
      }, 300);
    },
  },
});
